import { useEffect } from "react";
import { useStore } from "@tanstack/react-store";
import { createFileRoute, Link } from "@tanstack/react-router";
import { signOut } from "firebase/auth";
import { XCircle } from "lucide-react";
import { auth } from "@/firebase/app";
import { authStore } from "@/store/auth";
import { AuxPage } from "@/components/shared/AuxPage";
import { auxControlClass } from "@/components/shared/auxControl";

export const Route = createFileRoute("/_home/account-deleted")({
  component: AccountDeletedPage,
});

function AccountDeletedPage() {
  const user = useStore(authStore, (s) => s.user);

  useEffect(() => {
    if (!user) return;
    void signOut(auth).catch(() => {
      /* ignore */
    });
  }, [user]);

  const handleSignOut = () => {
    void signOut(auth).catch(() => {
      /* ignore */
    });
  };

  return (
    <AuxPage
      icon={
        <XCircle
          className="size-8 text-[color:var(--gs-muted)]"
          aria-hidden="true"
        />
      }
      title="Account deleted"
      status="Access revoked"
    >
      <p className="mb-8 text-sm leading-relaxed text-[color:var(--gs-text)]">
        Your account has been deleted. If you think this is a mistake, reach out
        to{" "}
        <a
          href="mailto:support@goodsender.com"
          className="text-[color:var(--gs-accent)] underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[color:var(--gs-accent)]"
        >
          support@goodsender.com
        </a>
        .
      </p>
      <div className="flex flex-col gap-3">
        <Link to="/" className={`${auxControlClass("secondary")} no-underline`}>
          Back to home
        </Link>
        {user && (
          <button
            type="button"
            onClick={handleSignOut}
            className="text-[color:var(--gs-muted)] text-[length:var(--gs-text-meta)] hover:text-[color:var(--gs-accent)] transition-colors"
          >
            Sign out
          </button>
        )}
      </div>
    </AuxPage>
  );
}
